"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({}, props, {
    width: "32",
    height: "28",
    viewBox: "0 0 32 28"
  }), /*#__PURE__*/_react["default"].createElement("g", null, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M30.06 1.6v3.78H1.6V1.6h28.46m.51-1.6H1.09A1.09 1.09 0 0 0 0 1.09v4.79A1.09 1.09 0 0 0 1.09 7h29.48a1.09 1.09 0 0 0 1.09-1.1V1.09A1.09 1.09 0 0 0 30.57 0zm-8 11.55v3.78H1.6v-3.78h21m.64-1.6H1a1 1 0 0 0-.95 1V16a1 1 0 0 0 1 1h22.18a1 1 0 0 0 1-1v-5.09a1 1 0 0 0-1-1zm-6 11.55v3.78H1.6V21.5h15.62m.78-1.6H.84a.85.85 0 0 0-.84.84V26a.85.85 0 0 0 .84.84H18a.85.85 0 0 0 .84-.84v-5.3a.85.85 0 0 0-.84-.8z"
  })));
};

exports["default"] = _default;